/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import Draggable from 'react-draggable';
import { closeIconBlack } from '../../../shared/assets/images';
import { defaultModalOptions } from '../../../shared/constantVariable';
import Notification from '../../../shared/notification-modal';
import './quick-view.scss';

const QuickViewPopUp = (props) => {
  const { visibleQuickView, closeQuickViewPopup, quickViewData } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  return (
    <Draggable handle='.shared-project-quick-view-box' cancel='.cancel-draggable'>
      <Modal
        hideBackdrop
        open={visibleQuickView}
        onClose={closeQuickViewPopup}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="quick-view-modal"
      >
        <Box className='shared-project-quick-view-box' display="flex">
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='quick-view-grid-container'>
            <Grid item xs={12} className='quick-view-header'>
              <div className='quick-view-header-text ft rufusBld cancel-draggable '>Project Details (Quick view)</div>
              <div className='quick-view-close-icon cancel-draggable'>
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={closeQuickViewPopup} style={{ display: 'block' }} className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='quick-view-body-container sansW4SeLig'>
              <Box sx={{ width: '100%', typography: 'body1' }} className='mixer-box-container'>
                <div className="quick-view-heading">
                  <div className='project-title cancel-draggable max'><span>File Name </span><span>{quickViewData.name ? quickViewData.name : '---'}</span></div>
                  <div className='customer-name cancel-draggable max'><span>Project Name </span><span>{quickViewData.project_name ? quickViewData.project_name : '---'}</span></div>
                  <div className='last-date cancel-draggable max'>
                    <div className='date'><span className='d'>Created On</span><span className='ld'>{quickViewData.created_on ? quickViewData.created_on : '--'}</span></div>
                    <div className='date'><span className='d'>Last Edited</span><span className='ld'>{quickViewData.last_edited_on ? quickViewData.last_edited_on : '--'}</span></div>
                  </div>
                </div>
                <div className="quick-view-content">
                  <span className='quick-details cancel-draggable'>Flow Sheet Details</span>
                  <div className='quick-view-data cancel-draggable'>
                    <ul className='quick-view-data-header'>
                      <li>Parameter</li>
                      <li>Details</li>
                    </ul>
                    <div className='quick-view-data-wrapper'>
                      <ul className='quick-view-data-containt'>
                        <li>Flow Sheet Type</li>
                        <li>{quickViewData.flow_type ?? '---'}</li>
                      </ul>
                      {[
                        { name: 'EDI', type: 'EDI' },
                        { name: 'ERD', type: 'ERD' },
                        { name: 'Chemical Dosing', type: 'Chemical_Dosing' },
                        { name: 'Stripper', type: 'Stripper' }
                      ].map((ele, ind) => {
                        return (
                          <ul key={ind} className='quick-view-data-containt'>
                            <li>{ele.name}</li>
                            <li>{quickViewData.unittop_sneak_peak_view && (quickViewData.unittop_sneak_peak_view[ele.type]) ? quickViewData.unittop_sneak_peak_view[ele.type].toString() : 'NA'}</li>
                          </ul>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Draggable>
  );
};
export default QuickViewPopUp;